/**
 * @generated SignedSource<<5bbe2642ec8e5ba4314f0d2e5eb99738>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type PracticeProblemsSessionQuery$variables = {
  skillId: string;
  skip: boolean;
  studentId: string;
};
export type PracticeProblemsSessionQuery$data = {
  readonly learnosityPracticeProblemsSession?: {
    readonly isActive: boolean;
    readonly sessionId: any;
  } | null | undefined;
};
export type PracticeProblemsSessionQuery = {
  response: PracticeProblemsSessionQuery$data;
  variables: PracticeProblemsSessionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skillId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skip"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "studentId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "skillId",
    "variableName": "skillId"
  },
  {
    "kind": "Variable",
    "name": "studentId",
    "variableName": "studentId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sessionId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PracticeProblemsSessionQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "LearnosityPracticeProblemsSessionNode",
            "kind": "LinkedField",
            "name": "learnosityPracticeProblemsSession",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "PracticeProblemsSessionQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "LearnosityPracticeProblemsSessionNode",
            "kind": "LinkedField",
            "name": "learnosityPracticeProblemsSession",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "b7533fe896bdbf11ddab01081d32625b",
    "id": null,
    "metadata": {},
    "name": "PracticeProblemsSessionQuery",
    "operationKind": "query",
    "text": "query PracticeProblemsSessionQuery(\n  $skillId: ID!\n  $studentId: ID!\n  $skip: Boolean!\n) {\n  learnosityPracticeProblemsSession(skillId: $skillId, studentId: $studentId) @skip(if: $skip) {\n    sessionId\n    isActive\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "baadfac73dec31539a347f1dd2d2fa03";

export default node;
